import { ActionCommonProps } from './action.types'
import { Action } from './generic-action'
import { faPen } from '@fortawesome/pro-solid-svg-icons'
import { useTranslation } from 'react-i18next'

export const EditAction = (props: ActionCommonProps) => {
  const { t } = useTranslation()

  return <Action {...props} icon={faPen} label={props.label ?? t('commons.edit')} color="var(--RichElectricBlue)" />
}
